/** @format */

import React, { Component } from 'react';
import AppTopMenu from './AppTopMenu/AppTopMenu';
import AppSideMenu from './AppSideMenu/AppSideMenu';
import { withRouter } from 'react-router-dom';
import { observer, inject } from 'mobx-react';

@inject('UserStore')
@observer
class AppLayout extends Component {
  state = {
    sidebar: {
      opened: false,
      activeItem: 'overview',
    },
  };

  handleSideItemClick = (name, url) => {
    this.props.history.push(url);
  };

  render() {
    return (
      <div>
        <AppTopMenu />
        <AppSideMenu
          handleSideItemClick={(name, url) =>
            this.handleSideItemClick(name, url)
          }
        >
          {this.props.children}
        </AppSideMenu>
      </div>
    );
  }
}

export default withRouter(AppLayout);
